import React from 'react';
import classNames from 'classnames';
import '../scss/HeaderFooterBase.scss';

/**
 * Vertical seperator to seperate component in Frame
 */

const FrameVR = ({
    className,
    ...otherProps
}) => (
    <div
        className={classNames('Frame__VR', className)}
        {...otherProps} />
);

export default FrameVR;
